import React from "react";
import styled from "styled-components";
import useCartErrors from "../../hooks/useCartErrors";

function CartErrors() {
  const [cartErrors] = useCartErrors();
  if (Array.isArray(cartErrors)) {
    const errors = cartErrors.filter(
      (error) => ignoreErrorCodes.indexOf(error.code) === -1
    );
    return (
      <ErrorsContainer>
        {errors.map((error, index) => (
          <ErrorEntry key={index}>{error.detail}</ErrorEntry>
        ))}
      </ErrorsContainer>
    );
  } else if (cartErrors) {
    return (
      <ErrorsContainer>
        <ErrorEntry>Unknown Error</ErrorEntry>
      </ErrorsContainer>
    );
  } else {
    return <></>;
  }
}

const ignoreErrorCodes = ["invalid_promo_code"];

const ErrorsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
const ErrorEntry = styled.p`
  font-size: ${({theme}) => theme.v2.typography.sizing.s.lg};
  color: #ec6f76;
  margin: ${({theme}) => theme.v2.spacing(2)} 0;
  font-weight: ${({theme}) => theme.v2.typography.bodyText1.weight.heavy};
`;

export default CartErrors;
